import { CriteriaLayoutProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Combinator } from 'modules/queryBuilder/types';
import uniqueId from 'lodash/uniqueId';
import {
  ActionButtonWrapper,
  CriteriaHeader,
  RequirementsWrapper,
  CriteriaFooter,
  CriteriaWrapper,
  CombinatorIconWrapper,
  CombinatorWrapper,
  TextWrapper,
  RequirementWithCombinatorWrapper,
  RequirementWrapper,
} from './CriteriaLayout.styles';
import { useCriteriaHeaderPretext } from './useCriteriaHeaderPretext';
import { AndIcon, NotIcon, OrIcon } from '../CombinatorIcons';

export const CRITERIA_DATA_TEST = {
  actionButtons: 'qb-ui-criteria-actions',
  requirements: 'qb-ui-criteria-requirements',
};

const getCombinatorIcon = (combinator: Combinator) => {
  switch (combinator) {
    case Combinator.NOT:
      return <NotIcon />;
    case Combinator.OR:
      return <OrIcon />;
    default:
      return <AndIcon />;
  }
};

export const CriteriaLayout = ({
  combinator,
  queryCombinator,
  isFirstElement,
  isReadOnly,
  UserProfileSelect,
  EventSelect,
  Requirements,
  CombinatorSelect,
  Delete,
  Duplicate,
}: CriteriaLayoutProps) => {
  const { t } = useTranslation();
  const isRequirementsVisible = Requirements.length > 0;
  const criteriaHeaderPretext = useCriteriaHeaderPretext(queryCombinator);

  return (
    <CriteriaWrapper>
      <CriteriaHeader data-hasmargin={Requirements.length > 0} key={uniqueId()}>
        <CombinatorWrapper>
          {!isFirstElement && <TextWrapper>{criteriaHeaderPretext}</TextWrapper>}
          {CombinatorSelect}
          <TextWrapper>{t('storybook.layouts.criteria.postText')}</TextWrapper>
        </CombinatorWrapper>
        <ActionButtonWrapper
          data-test={CRITERIA_DATA_TEST.actionButtons}
          id={CRITERIA_DATA_TEST.actionButtons}
        >
          {Duplicate}
          {!!Delete && Delete}
        </ActionButtonWrapper>
      </CriteriaHeader>
      {isRequirementsVisible && (
        <RequirementsWrapper data-test={CRITERIA_DATA_TEST.requirements}>
          {Requirements.map((Requirement, i) => (
            <RequirementWithCombinatorWrapper key={uniqueId()}>
              <CombinatorIconWrapper>{getCombinatorIcon(combinator)}</CombinatorIconWrapper>
              <RequirementWrapper data-combinator={combinator}>{Requirement}</RequirementWrapper>
            </RequirementWithCombinatorWrapper>
          ))}
        </RequirementsWrapper>
      )}
      {!isReadOnly && (
        <CriteriaFooter data-hasmargin={Requirements.length > 0}>
          {UserProfileSelect}
          {EventSelect}
        </CriteriaFooter>
      )}
    </CriteriaWrapper>
  );
};
